import { startCase } from 'lodash';

const getNextChar = (c: string): string => {
  const charIncrementer = (c: string) => {
    return c.toLowerCase() === 'z'
      ? 'a'
      : String.fromCharCode(c.charCodeAt(0) + 1);
  };

  const chars = c.toLowerCase().split('');
  const currentChar = c[0];

  if (currentChar === 'z') {
    return new Array(chars.length + 1).fill('a').join('');
  }

  const next = charIncrementer(currentChar);
  return chars.map((_) => next).join('');
};

/**
 * Returns the text, uppercasing the first letter of each word.
 */
export const toTitleCase = (value: string): string => {
  return startCase(value.toLowerCase());
};

export { getNextChar };
